// tenantConfig.js
export const tenantConfigs = {
  tenants: {
    DEFAULT: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      readOnlyProfile: false,
      requiredProfileFields: ["firstname", "surname", "company"],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: true,
      storeFullProfilePoints: false,
      linkInWelcomeBox: "stammdaten",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      showPointsExpirySummary: false,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: false,
      profileVersion: "Lite",
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      serviceNumberBreadcrumbsParentRoutes: [],
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: false,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: false,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: false,
      showBrochureDateSort: true,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: false,
      bDriveSimpleLink: false,
      kickbackFeePointsKey: "kick_back_fee",
      sellerDashboardFullNameTitle: false,
      sellerDashboardShowYearPoints: false,
      sellerDashboardShowDealerTotals: false,
      sellerDashboardShowKickbacks: false,
      sellerDashboardShowTyres: false,
      sellerDashboardShowYearSearch: false,
      sellerDashboardShowLoadAll: false,
      sellerDashboardShowAttributeDownload: false,
      sellerDashboardShowExcelExport: false,
      sellerDashboardShowExports: false,
      wholesalerDashboardIsGermany: false,
      wholesalerDashboardIsSwitzerland: false,
      wholesalerDashboardIsNetherland: false,
      useTyreBoxLeftColumnLayout: false,
      showShopPerPageSelect: false,
      showNlCarwashBanner: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showBonusMultiplicator: false,
      showMailBox: true,
    },
    DE: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: false,
      modules: [],
      profileFieldsExtraHide: ["indirectCustomNumberHelpMessage"],
      readOnlyProfile: false,
      requiredProfileFields: [
        "firstname",
        "surname",
        "company",
        "countrySelect",
      ],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: true,
      storeFullProfilePoints: true,
      linkInWelcomeBox: "stammdaten",
      linkInWelcomeBoxStaff: "account",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      showPointsExpirySummary: true,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainingCategory",
      extendedOnlineTrainigs: true,
      showWelcomePointsInfo: true,
      profileVersion: "German",
      showServiceNumberPage: true,
      showServiceNumberContactButtons: false,
      serviceNumberBreadcrumbsParentRoutes: [],
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: true,
      showPkwFsQuestion: true,
      showMotQuestion: true,
      showBrochurePrices: true,
      showDataGenerator: true,
      showProductBrochures: false,
      showPriceList: false,
      showPricat: true,
      showFuelCalculator: true,
      showBDrive: true,
      showBDriveProductInfo: true,
      bDriveLink: "https://www.b-drive.com/en.html",
      showBrochures: false,
      showTyreSizeField: true,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: true,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: false,
      bDriveSimpleLink: true,
      sellerDashboardFullNameTitle: false,
      sellerDashboardShowYearPoints: false,
      sellerDashboardShowDealerTotals: true,
      sellerDashboardShowKickbacks: false,
      sellerDashboardShowTyres: false,
      sellerDashboardShowYearSearch: false,
      sellerDashboardShowLoadAll: false,
      sellerDashboardShowAttributeDownload: false,
      sellerDashboardShowExcelExport: true,
      sellerDashboardShowExports: false,
      wholesalerDashboardIsGermany: true,
      wholesalerDashboardIsSwitzerland: false,
      wholesalerDashboardIsNetherland: false,
      useTyreBoxLeftColumnLayout: false,
      showShopPerPageSelect: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    CH: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: false,
      showLogo: true,
      modules: [],
      profileFieldsExtraHide: ["indirectCustomNumberHelpMessage"],
      readOnlyProfile: false,
      requiredProfileFields: ["firstname", "surname", "company", "language"],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: true,
      storeFullProfilePoints: true,
      linkInWelcomeBox: "stammdaten",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: true,
      profileVersion: "German",
      showServiceNumberPage: true,
      showServiceNumberContactButtons: false,
      serviceNumberBreadcrumbsParentRoutes: [],
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: true,
      showPricat: true,
      showFuelCalculator: false,
      showBDrive: true,
      showBDriveProductInfo: true,
      bDriveLink: "https://www.b-drive.com/en.html",
      showBrochures: true,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: true,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "customerservice@bridgestone.eu",
      showToolTip: false,
      bDriveSimpleLink: true,
      sellerDashboardFullNameTitle: false,
      sellerDashboardShowYearPoints: false,
      sellerDashboardShowDealerTotals: true,
      sellerDashboardShowKickbacks: false,
      sellerDashboardShowTyres: false,
      sellerDashboardShowYearSearch: false,
      sellerDashboardShowLoadAll: false,
      sellerDashboardShowAttributeDownload: false,
      sellerDashboardShowExcelExport: false,
      sellerDashboardShowExports: false,
      wholesalerDashboardIsGermany: false,
      wholesalerDashboardIsSwitzerland: true,
      wholesalerDashboardIsNetherland: false,
      useTyreBoxLeftColumnLayout: false,
      showShopPerPageSelect: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    NL: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--rotated",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      profileFieldsExtraShow: [
        "salutation",
        "job_position",
        "mobile_phone",
        "iban_number",
        "btw_number",
      ],
      profileFieldsExtraHide: ["indirectCustomNumberHelpMessage"],
      readOnlyProfile: false,
      requiredProfileFields: [
        "firstname",
        "surname",
        "salutation",
        "company",
        "street",
        "postal_code",
        "city",
        "mobile_phone",
      ],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: true,
      storeFullProfilePoints: true,
      linkInWelcomeBox: "stammdaten",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: true,
      showIbanInfo: true,
      showCurrentMonthPointsInfo: true,
      canSeeTenantEmails: true,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: true,
      profileVersion: "Netherland",
      showServiceNumberPage: true,
      showServiceNumberContactButtons: true,
      serviceNumberBreadcrumbsParentRoutes: ["contact_service"],
      showStrategicPartners: true,
      showTouchIncentive: true,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: true,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: true,
      bDriveLink: "https://www.b-drive.com/en.html",
      showBrochures: true,
      showTyreSizeField: false,
      showLogoAtMaintenance: true,
      hintMaxStep: 5,
      showLastMonthPointsInfo: true,
      showBsStaffAtProfile: true,
      menuQuestionMarkLink: "contact_service",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: false,
      bDriveSimpleLink: true,
      sellerDashboardFullNameTitle: true,
      sellerDashboardShowYearPoints: true,
      sellerDashboardShowDealerTotals: false,
      sellerDashboardShowKickbacks: true,
      sellerDashboardShowTyres: true,
      useTyreBoxLeftColumnLayout: true,
      showShopPerPageSelect: true,
      sellerDashboardShowYearSearch: true,
      sellerDashboardShowLoadAll: true,
      sellerDashboardShowAttributeDownload: true,
      sellerDashboardShowExcelExport: false,
      sellerDashboardShowExports: true,
      wholesalerDashboardIsGermany: false,
      wholesalerDashboardIsSwitzerland: false,
      wholesalerDashboardIsNetherland: true,
      showNlCarwashBanner: true,
      showBDriveProductInfo: true,
      showRedSlashInbox: true,
      canAddNewCustomerNumber: false,
      showPlusWord: true,
      showCurrentMonthPointsSpendings: false,
      showBonusMultiplicator: true,
      showBrochureDateSort: false,
      showMailBox: false,
    },
    FR: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      readOnlyProfile: false,
      profileFieldsExtraShow: ["countrySelect", "mobile_phone"],
      requiredProfileFields: [
        "firstname",
        "surname",
        "company",
        "street",
        "postal_code",
        "city",
        "country",
      ],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: true,
      allowOnboard: true,
      linkInWelcomeBox: "stammdaten",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: true,
      showRedSlashPointOverview: false,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: false,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: false,
      profileVersion: "Lite",
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      serviceNumberBreadcrumbsParentRoutes: ["contact_service"],
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: true,
      showPremiumPartnerContact: true,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: true,
      showPriceList: false,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: true,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: true,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: true,
      bDriveSimpleLink: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    PT: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      readOnlyProfile: false,
      profileFieldsExtraShow: ["countrySelect", "mobile_phone"],
      requiredProfileFields: ["firstname", "surname", "company"],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: true,
      allowOnboard: true,
      linkInWelcomeBox: "stammdaten",
      indirectCanSeeCustomerNumberForm: true,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: false,
      profileVersion: "Lite",
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      serviceNumberBreadcrumbsParentRoutes: ["contact_service"],
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: false,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: false,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: false,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: true,
      bDriveSimpleLink: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    ES: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      readOnlyProfile: false,
      profileFieldsExtraShow: ["countrySelect", "mobile_phone"],
      requiredProfileFields: [
        "firstname",
        "surname",
        "company",
        "street",
        "postal_code",
        "city",
        "countrySelect",
      ],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: true,
      allowOnboard: true,
      linkInWelcomeBox: "stammdaten",
      indirectCanSeeCustomerNumberForm: true,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: false,
      profileVersion: "Lite",
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      serviceNumberBreadcrumbsParentRoutes: ["contact_service"],
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: false,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: false,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: false,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: true,
      bDriveSimpleLink: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    BE: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      profileFieldsExtraShow: ["countrySelect", "mobile_phone", "iban_number"],
      requiredProfileFields: [
        "firstname",
        "surname",
        "company",
        "street",
        "postal_code",
        "city",
        "country",
      ],
      readOnlyProfile: false,
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: true,
      linkInWelcomeBox: "stammdaten",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: true,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: false,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: false,
      profileVersion: "Lite",
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      serviceNumberBreadcrumbsParentRoutes: ["contact_service"],
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: true,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: false,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: true,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: true,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: true,
      bDriveSimpleLink: false,
      kickbackFeePointsKey: "kick_back_fee_tbr",
      showPremiumPartnerContact: true,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    AT: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      readOnlyProfile: false,
      profileFieldsExtraHide: ["indirectCustomNumberHelpMessage"],
      profileFieldsExtraShow: ["countrySelect", "mobile_phone"],
      requiredProfileFields: ["firstname", "surname", "company"],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: true,
      storeFullProfilePoints: true,
      linkInWelcomeBox: "stammdaten",
      linkInWelcomeBoxStaff: "account",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: true,
      profileVersion: "Lite",
      swapProfileTabs: true,
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: true,
      showProductBrochures: false,
      showPriceList: false,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: true,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: false,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: true,
      bDriveSimpleLink: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    FI: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      profileFieldsExtraHide: ["title", "legalForm"],
      profileFieldsExtraShow: ["countrySelect", "mobile_phone"],
      readOnlyProfile: false,
      requiredProfileFields: ["firstname", "surname", "company"],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: true,
      linkInWelcomeBox: "stammdaten",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: false,
      profileVersion: "Lite",
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: false,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: false,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: false,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: true,
      bDriveSimpleLink: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    SE: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      profileFieldsExtraHide: ["title", "legalForm"],
      profileFieldsExtraShow: ["countrySelect", "mobile_phone"],
      readOnlyProfile: false,
      requiredProfileFields: ["firstname", "surname", "company"],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: true,
      linkInWelcomeBox: "stammdaten",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: false,
      profileVersion: "Lite",
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: false,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: false,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: false,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: true,
      bDriveSimpleLink: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    DK: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      profileFieldsExtraShow: ["countrySelect", "mobile_phone"],
      profileFieldsExtraHide: ["title", "legalForm", "salutation"],
      readOnlyProfile: false,
      requiredProfileFields: ["firstname", "surname", "company"],
      requiredOnboardSteps: [1, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: true,
      linkInWelcomeBox: "stammdaten",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: false,
      profileVersion: "Lite",
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: false,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: false,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: false,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: true,
      bDriveSimpleLink: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    IE: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      readOnlyProfile: false,
      profileFieldsExtraShow: ["countrySelect", "mobile_phone"],
      requiredProfileFields: ["firstname", "surname", "company"],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: true,
      linkInWelcomeBox: "stammdaten",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: false,
      profileVersion: "Lite",
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: false,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: false,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: false,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: true,
      bDriveSimpleLink: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    UK: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      readOnlyProfile: false,
      profileFieldsExtraShow: ["countrySelect", "mobile_phone"],
      requiredProfileFields: ["firstname", "surname", "company"],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: true,
      linkInWelcomeBox: "stammdaten",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: false,
      profileVersion: "Lite",
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: false,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: false,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: false,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: true,
      bDriveSimpleLink: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    IT: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      readOnlyProfile: true,
      requiredProfileFields: ["firstname", "surname", "company"],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: false,
      linkInWelcomeBox: "account",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: false,
      profileVersion: "Lite",
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: false,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: false,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: false,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: true,
      bDriveSimpleLink: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    RO: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      readOnlyProfile: true,
      requiredProfileFields: ["firstname", "surname", "company"],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: false,
      linkInWelcomeBox: "account",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: false,
      profileVersion: "Lite",
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: false,
      showFuelCalculator: false,
      showBDrive: false,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: false,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: true,
      bDriveSimpleLink: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    EE: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      readOnlyProfile: false,
      profileFieldsExtraShow: ["countrySelect", "mobile_phone"],
      requiredProfileFields: ["firstname", "surname", "company"],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: true,
      linkInWelcomeBox: "stammdaten",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: false,
      profileVersion: "Lite",
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: false,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: false,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: false,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: true,
      bDriveSimpleLink: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    LV: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      readOnlyProfile: false,
      profileFieldsExtraShow: ["countrySelect", "mobile_phone"],
      requiredProfileFields: ["firstname", "surname", "company"],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: true,
      linkInWelcomeBox: "stammdaten",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: false,
      profileVersion: "Lite",
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: false,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: false,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: false,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: true,
      bDriveSimpleLink: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    LT: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      readOnlyProfile: false,
      profileFieldsExtraShow: ["countrySelect", "mobile_phone"],
      requiredProfileFields: ["firstname", "surname", "company"],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: true,
      linkInWelcomeBox: "stammdaten",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: false,
      profileVersion: "Lite",
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: false,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: false,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: false,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: true,
      bDriveSimpleLink: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    CZ: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      readOnlyProfile: false,
      profileFieldsExtraShow: ["countrySelect", "mobile_phone"],
      requiredProfileFields: ["firstname", "surname", "company"],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: true,
      linkInWelcomeBox: "stammdaten",
      indirectCanSeeCustomerNumberForm: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: false,
      profileVersion: "Lite",
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: false,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: false,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: false,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: true,
      bDriveSimpleLink: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    HU: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      readOnlyProfile: false,
      profileFieldsExtraShow: ["countrySelect", "mobile_phone"],
      requiredProfileFields: ["firstname", "surname", "company"],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: true,
      linkInWelcomeBox: "stammdaten",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: false,
      profileVersion: "Lite",
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: false,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: false,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: false,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: true,
      bDriveSimpleLink: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    PL: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      readOnlyProfile: false,
      profileFieldsExtraShow: ["countrySelect", "mobile_phone"],
      requiredProfileFields: ["firstname", "surname", "company"],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: true,
      linkInWelcomeBox: "stammdaten",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: false,
      profileVersion: "Lite",
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: false,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: false,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: false,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: true,
      bDriveSimpleLink: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    SK: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      readOnlyProfile: false,
      profileFieldsExtraShow: ["countrySelect", "mobile_phone"],
      requiredProfileFields: ["firstname", "surname", "company"],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: true,
      linkInWelcomeBox: "stammdaten",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: false,
      profileVersion: "Lite",
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: false,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: false,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: false,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: true,
      bDriveSimpleLink: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    BG: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      readOnlyProfile: false,
      requiredProfileFields: ["firstname", "surname", "company"],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: true,
      linkInWelcomeBox: "stammdaten",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: false,
      profileVersion: "Lite",
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: false,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: false,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: false,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: true,
      bDriveSimpleLink: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
    NO: {
      topLogo: require("@/assets/img/B_MarkLogo.svg"),
      logo: require("@/assets/img/bs_logo_solution.svg"),
      background: "background--default",
      showTopLogo: true,
      showLogo: true,
      modules: [],
      readOnlyProfile: false,
      profileFieldsExtraShow: ["countrySelect", "mobile_phone"],
      requiredProfileFields: ["firstname", "surname", "company"],
      requiredOnboardSteps: [1, 2, 3],
      allowDuplicatedCustomerNumber: false,
      allowOnboard: true,
      linkInWelcomeBox: "stammdaten",
      indirectCanSeeCustomerNumberForm: false,
      textOverPoints: false,
      showRedSlashPointOverview: true,
      showDealerKickbackFeeInfo: false,
      showIbanInfo: false,
      showCurrentMonthPointsInfo: true,
      canSeeTenantEmails: false,
      linkForOnlineTrainings: "onlineTrainings",
      extendedOnlineTrainigs: false,
      showWelcomePointsInfo: false,
      profileVersion: "Lite",
      showServiceNumberPage: false,
      showServiceNumberContactButtons: true,
      showStrategicPartners: false,
      showTouchIncentive: false,
      showBridgestoneContact: false,

      showPkwQuestion: false,
      showPkwFsQuestion: false,
      showMotQuestion: false,
      showBrochurePrices: false,
      showDataGenerator: false,
      showProductBrochures: false,
      showPriceList: false,
      showPricat: false,
      showFuelCalculator: false,
      showBDrive: false,
      showBDriveProductInfo: false,
      bDriveLink: { name: "bDrive" },
      showBrochures: false,
      showTyreSizeField: false,
      showLogoAtMaintenance: false,
      hintMaxStep: 4,
      showLastMonthPointsInfo: false,
      showBsStaffAtProfile: false,
      menuQuestionMarkLink: "service_number",
      showCsNrInfoInProfile: false,
      contactEmail: "plus@bridgestone.eu",
      showToolTip: true,
      bDriveSimpleLink: false,
      showRedSlashInbox: false,
      canAddNewCustomerNumber: true,
      showPlusWord: false,
      showCurrentMonthPointsSpendings: true,
      showMailBox: true,
    },
  },
};
